// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"expand-down"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 3H3V16H21V3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 21H21V16H3V21Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 16V3H21V16M3 16H21M3 16V21H21V16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 10.5L10 8.5H14L12 10.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ExpandDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'expand-down',
    ref,
    icon: element,
  },
));

ExpandDownIcon.displayName = 'ExpandDownIcon';

export default ExpandDownIcon;
